import { useEffect, useState } from 'react';
import { CotizadorModelo } from '../../../modelos/CotizadorNBS';
import { useAvisoErrorConsulta } from './useAvisoErrorConsulta';

export interface IMonedaPais {
    /** Moneda local (COP, USD): viáticos y resultados locales. */
    monedaLocal: string;
    /** Solo los países con moneda local distinta del dólar usan TRM (Colombia). */
    usaTrm: boolean;
}

/** Solo los países en dólares no usan TRM. Se decide con la moneda (misma regla que PaisNBS.UsaTrm del back). */
export const monedaUsaTrm = (moneda?: string) => (moneda?.trim() || 'COP') !== 'USD';

/** Mientras carga, la TRM queda oculta y sin moneda: se muestran solo cuando se sabe el país
 * (así en países en dólares no aparece la TRM por un instante). */
const PREDETERMINADA: IMonedaPais = { monedaLocal: '', usaTrm: false };

/** Moneda del país: la configuración va en USD, salvo los viáticos, que van en la moneda local. */
export const useMonedaPais = (paisId?: number): IMonedaPais => {
    const [moneda, setMoneda] = useState<IMonedaPais>(PREDETERMINADA);
    const avisarErrorConsulta = useAvisoErrorConsulta();

    useEffect(() => {
        if (!paisId) return;
        let vigente = true;
        new CotizadorModelo().obtenerPais(paisId)
            .then(respuesta => {
                if (vigente && respuesta?.Data) {
                    const monedaLocal = respuesta.Data.Moneda?.trim() || 'COP';
                    setMoneda({ monedaLocal, usaTrm: monedaUsaTrm(monedaLocal) });
                }
            })
            .catch(error => avisarErrorConsulta(error, 'la moneda del país'));
        return () => { vigente = false; };
    }, [paisId, avisarErrorConsulta]);

    return moneda;
};
